import React, { useEffect, useState } from "react";
import { ToolPanel } from "../../../pages/orders/my/tool-panel/tool-panel";
import LocationsList from "./list/locations-list";
import { OrderModel } from "../../../pages/shared/models/order/order-item.model";
import { LocationResponseModel } from "./model/location-response.model";
import { LocationTableColumn, LocationTableColumnTypes } from "./model/location-table-column.model";
import { useAppSelector } from "../../../redux/store";
import ordersService from "../../../services/orders.service";

const locationColumn: LocationTableColumn = { headerName: 'location', variant: LocationTableColumnTypes.NAME };
const totalValueColumn: LocationTableColumn = { headerName: 'total_value', variant: LocationTableColumnTypes.TOTAL_PAYMENTS };
const totalWeightColumn: LocationTableColumn = { headerName: 'total_weight', variant: LocationTableColumnTypes.TOTAL_WEIGHT };
const orderCountColumn: LocationTableColumn = { headerName: 'order_count', variant: LocationTableColumnTypes.TOTAL_ORDERS_COUNT };
const addColumn: LocationTableColumn = { headerName: 'actions', variant: LocationTableColumnTypes.ADD_ORDER };

const columns = [
    locationColumn,
    totalValueColumn,
    totalWeightColumn,
    orderCountColumn,
    addColumn,
]

export const LocationTable = ({ orders }: LocationTableProps) => {
    const [isReady, setIsReady] = useState<boolean>(false);
    const [selectedOrders, setSelectedOrders] = useState(new Map<number, OrderModel>());
    const [exportableOrders, setExportableOrders] = useState<OrderModel[]>([]);
    const { orderStateId } = useAppSelector(state => state.ordersReducer);
    const [filter, setFilter] = useState<any>();

    const [locationsResponseData, setLocationsResponseData] = useState({
        data: [],
        page: 0,
        pageSize: 10,
        totalGroups: 0,
        totalPages: 0,
    } as LocationResponseModel);

    useEffect(() => {
        setFilter({ state: orderStateId });
        const filteredOrders = orders.filter(order => order.depot);
        setExportableOrders(filteredOrders);
    }, [orderStateId])

    useEffect(() => {
        setLocationsResponseData({
            data: [],
            page: 0,
            pageSize: 10,
            totalGroups: 0,
            totalPages: 0,
        });

        if (filter) {
            ordersService.getCombinedByLocation(filter, locationsResponseData.pageSize, 0)
                .then(response => {
                    setLocationsResponseData(response);

                    setIsReady(true);
                })
        }
    }, [filter])

    function handlePageChange(event: any, newPage: number): void {
        ordersService.getCombinedByLocation(filter, locationsResponseData.pageSize, newPage)
            .then(response => {
                setLocationsResponseData(response);

                setIsReady(true);
            })
    }

    return (
        <>
            <ToolPanel selectedOrders={selectedOrders} isWarehouseWorker={true} orderStateId={orderStateId} exportableOrders={exportableOrders} />
            {isReady && <LocationsList columns={columns} locationsData={locationsResponseData} handlePageChange={handlePageChange} />}
        </>
    )
}

interface LocationTableProps {
    orders: OrderModel[],
}
